export default "__VITE_ASSET__DVCHgFj9__"